import React from 'react';
import randomstring from 'uuid/v4';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { bindActionCreators } from 'redux';

import Table from './Table';

import Error from '../../../dialogs/Error';
import Loading from '../../../dialogs/loading';
import Snackbar from '../../../labels/Snackbar';
import { getTotalSecondsDiference, formatDate } from '../../../../functions/time';

import * as actions from '../../../../actions/api.reports.decrease.actions';
import * as home from '../../../../actions/process.home.actions';

// eslint-disable-next-line
import style from './_style.css';


class Products extends React.Component {
    state = {
        hide: false,
        open: undefined,
        error: undefined,
        from: undefined,
        to: undefined,
        local: undefined,
    }

    static getDerivedStateFromProps(props, state) {
        const { report_decrease_locals, report_decrease } = props;
        if (
            report_decrease_locals !== state.report_decrease_locals ||
            report_decrease !== state.report_decrease
        ) {
            state.report_decrease_locals = report_decrease_locals;
            state.report_decrease = report_decrease;
            const aux = report_decrease.reduce((groups, item) => {
                const val = item.id_local;
                if (!groups[val]) {
                    groups[val] = {
                        id_local: item.id_local,
                        nombre_local: item.nombre_local,
                        from: '',
                        to: '',
                        percentage: 0,
                        cantidad: 0,
                        merma: 0,
                        details: [],
                    };
                }
                groups[val].details.push(item);
                return groups;
            }, {});
            state.data = Object.keys(aux).map((i) => {
                const local = aux[i];
                const products = local.details.reduce((product, l) => {
                    const val = l.id_producto;
                    if (!product[val]) {
                        local.cantidad += l.cantidad;
                        local.merma += l.merma;
                        product[val] = {
                            cantidad: l.cantidad,
                            merma: l.merma,
                            nombre_producto: l.nombre_producto,
                            from: l.finproduccion,
                            to: l.finproduccion,
                            details: [l],
                        };
                    } else {
                        local.cantidad += l.cantidad;
                        local.merma += l.merma;
                        product[val].cantidad += l.cantidad;
                        product[val].merma += l.merma;
                        product[val].from = product[val].from < l.finproduccion ? product[val].from : l.finproduccion;
                        product[val].to = product[val].to > l.finproduccion ? product[val].to : l.finproduccion;
                        product[val].details.push(l);
                    }
                    return product;
                }, {});
                delete local.details;
                local.resumen = Object.keys(products).map((i) => products[i]);
                local.from = local.resumen.reduce((min, i) => {
                    if (!min || getTotalSecondsDiference(i.from, min) === 0) {
                        min = i.from;
                    }
                    return min;
                }, undefined);
                local.to = local.resumen.reduce((max, i) => {
                    if (!max || getTotalSecondsDiference(max, i.to) === 0) {
                        max = i.to;
                    }
                    return max;
                }, undefined);

                console.log(local);
                return local;
            });
            return state;
        }
        return null;
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleBack = () => {
        /*
            let path = this.props.history.location.pathname.split('/');
            path.splice(path.length - 1, 1);
            path = path.join('/');
            this.props.history.push(path);
            */
           if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    handleClose = () => {
        this.setState({ error: '' });
    };

    render() {
        const { info, report_decrease_is_loading } = this.props;
        const { error, data } = this.state;

        const Item = (local) => (
            <div className="margin_bottom_24 padding_borders">
                <div className="flex_auto_row padding_bottom_9 shadow_down_only barlowcondensed_regular_number c_grey_blue">
                    <div className="flex_auto_row">
                        {local.nombre_local}
                    </div>
                    <div className="flex_auto_row margin_left_12">
                        {"[" + formatDate(local.from) + " - "}
                    </div>
                    <div className="flex_auto_row margin_left_2">
                        {formatDate(local.to) + "]"}
                    </div>
                    <div className="flex_auto_row margin_left_12">
                        {Math.round(((local.merma * 100) / local.cantidad) * 100) / 100 + "%"}
                    </div>
                </div>
                <Table
                    data={local.resumen
                        .sort((a, b) => (a.nombre_producto > b.nombre_producto ? 1 : -1))
                        .map((i) => i)}
                />
            </div>
        );

        console.log(data);
        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '20' || f === '60') &&
              info.security.licencias.some((f) => f.id === 154 && f.activo ))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else {
            return (
                <div className={'flex_full_row bg_ice_blue'}>
                    {report_decrease_is_loading && <Loading open opacity />}
                    <div
                        className={
                            'flex_full_column overflow_y_scroll showbar padding_top_12  height100 bg_ice_blue'
                        }
                    >
                        {data.map((local) => {
                            return <Item key={randomstring()} {...local} />;
                        })}
                    </div>
                    {error && (
                        <Snackbar
                            open={true}
                            variant="error"
                            text={error}
                            nonavbar={true}
                            onClose={this.handleClose}
                        />
                    )}
                </div>
            );
        }
    }
}

const mapStateToProps = (state) => {
    return {
        info: state.info,
        report_decrease_is_loading: state.report_decrease_is_loading,
        report_decrease: state.report_decrease,
        report_decrease_locals: state.report_decrease_locals,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, home), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(Products));



// WEBPACK FOOTER //
// ./src/components/complex/reports/decrease/List.js